import {
  any,
  arrayOf,
  shape,
  string,
} from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';

import { Divider } from 'components';
import CodeControl from 'components/DynamicForm/controls/CodeControl';

const useStyles = makeStyles((theme) => ({
  root: {},
  fontWeightMedium: {
    verticalAlign: 'top',
    fontWeight: theme.typography.fontWeightMedium,
    wordBreak: 'break-word',
  },
}));

function KeyValueList({ items, width }) {
  const classes = useStyles();

  return (
    <Table style={{
      tableLayout: 'fixed',
    }}>
      <TableBody>
        {items && items.map((item, index) => {
          let { label = '', value = '' } = item;

          if (Array.isArray(item)) {
            [label, value] = item;
          }

          const isUrl = typeof value === 'string' && /^https?:\/\/\S+$/i.test(value);
          if (isUrl) {
            value = (
              <a href={value} target="_blank" rel="noopener noreferrer">
                {value}
              </a>
            );
          }

          if (typeof value === 'object' && !Array.isArray(value) && !value?.props && value !== null) {
            value = <CodeControl
              disabled
              settings={{
                lang: 'json',
                lineNumbers: false,
              }}
              value={JSON.stringify(value, null, '\t')}
            />;
          }

          return (<>
            <TableRow key={index}>
              {(label !== false) && <TableCell
                children={label}
                className={classes.fontWeightMedium}
                {...width && {
                  style: {
                    width: width,
                  },
                }}
              />}

              <TableCell colSpan={label !== false ? undefined : 2}>
                <Typography
                  children={Array.isArray(value)
                    ? `${value.length} elementos`
                    : value}
                  color="textSecondary"
                  variant="body2"
                  style={{
                    wordBreak: label !== false ? 'break-word' : 'normal',
                  }}
                />
              </TableCell>
            </TableRow>

            {Array.isArray(value) && (value.map((v, i) => {
              let subVal = v;
              if (Array.isArray(subVal)) {
                subVal = (<KeyValueList items={v} />);
              } else if (typeof subVal === 'object' && subVal !== null) {
                subVal = (
                  <KeyValueList
                    items={Object.entries(v)}
                    {...width && {
                      width,
                    }}
                  />
                );
              }

              return (<TableRow key={i} >
                <TableCell colSpan={2}>
                  <Divider children={`[${i}]`} />
                  {subVal}
                </TableCell>
              </TableRow>);
            }))}
          </>);
        })}
      </TableBody>
    </Table >
  );
}

KeyValueList.propTypes = {
  items: arrayOf(shape({
    label: string,
    value: any,
  })),
  width: string,
};

export default KeyValueList;
